import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const GlutenIcon = ({
  innerColor = '#fefefe',
  outerColor = '#ee7440',
  ...props
}: AllergnIconProps) => {
  const style = {
    fill: innerColor,
  };

  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_121"
        data-name="Grupo 121"
        transform="translate(-183.584 -2094)"
      >
        <g
          id="Rectángulo_18"
          data-name="Rectángulo 18"
          transform="translate(183.584 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="gluten-free" transform="translate(190.501 2100.917)">
          <path
            id="Trazado_9073"
            data-name="Trazado 9073"
            d="M25.811,10.558a3.632,3.632,0,0,0,.906-2.647,3.739,3.739,0,0,0-1.391-2.606.3.3,0,0,0-.4.009l-.1.092a3.861,3.861,0,0,0-1.25-1.846.3.3,0,0,0-.4.009l-.1.092a3.861,3.861,0,0,0-1.25-1.846.3.3,0,0,0-.4.009l-.1.092A3.859,3.859,0,0,0,20.09.07a.3.3,0,0,0-.4.009,3.942,3.942,0,0,0-1,1.4A4.192,4.192,0,0,0,15.553.447a.3.3,0,0,0-.281.281A4.191,4.191,0,0,0,16.3,3.869a3.94,3.94,0,0,0-1.4,1,.3.3,0,0,0-.009.4,3.86,3.86,0,0,0,1.846,1.25q-.047.048-.092.1a.3.3,0,0,0-.009.4,3.86,3.86,0,0,0,1.846,1.25q-.047.048-.092.1a.3.3,0,0,0-.009.4,3.86,3.86,0,0,0,1.846,1.25q-.047.048-.092.1a.3.3,0,0,0-.009.4,3.737,3.737,0,0,0,2.6,1.391q.128.009.255.009a3.655,3.655,0,0,0,2.393-.916l1.131,1.131a.3.3,0,1,0,.428-.428ZM23.4,4.208a3.14,3.14,0,0,1,.944,1.768,3.6,3.6,0,0,0-.671,2.441l-.907-.907a3,3,0,0,1,.634-3.3ZM21.652,2.462A3.14,3.14,0,0,1,22.6,4.231a3.6,3.6,0,0,0-.671,2.441l-.907-.907A3,3,0,0,1,21.652,2.462ZM19.906.717a3.138,3.138,0,0,1,.945,1.768,3.6,3.6,0,0,0-.671,2.44l-.906-.906a3,3,0,0,1,.633-3.3Zm-4.04.324h.023a3.509,3.509,0,0,1,2.6,1.087A3.482,3.482,0,0,0,18.523,3.7a3.485,3.485,0,0,0-1.57-.032,3.512,3.512,0,0,1-1.087-2.626Zm-.324,4.041a3,3,0,0,1,3.3-.634l.906.906a3.6,3.6,0,0,0-2.441.671,3.134,3.134,0,0,1-1.768-.944Zm1.745,1.745a3,3,0,0,1,3.3-.634L21.5,7.1a3.6,3.6,0,0,0-2.441.671A3.135,3.135,0,0,1,17.287,6.827Zm1.745,1.745a3,3,0,0,1,3.3-.634l.907.907a3.6,3.6,0,0,0-2.441.671A3.134,3.134,0,0,1,19.033,8.572Zm3.746,2.717a3.092,3.092,0,0,1-2-.971,3,3,0,0,1,3.3-.634l.873.873A3.028,3.028,0,0,1,22.779,11.289Zm2.6-1.16-.873-.873a3,3,0,0,1,.634-3.3,3.093,3.093,0,0,1,.971,2,3.026,3.026,0,0,1-.732,2.173Z"
            transform="translate(-14.825 0)"
          />
          <path
            id="Trazado_9075"
            data-name="Trazado 9075"
            d="M429.614,414.847a.3.3,0,0,0,0,.428h0a.3.3,0,1,0,0-.429Z"
            transform="translate(-416.966 -402.198)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default GlutenIcon;
